(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.fileuploader
   * @description
   *
   */
  angular
    .module('utils.fileuploader', [
      'ui.router'
    ]);
}());
